import api from "./axios";

/**
 * Submit a bug report (authenticated). Sends multipart/form-data.
 * @param {{ title: string, description: string, files: File[] }} payload
 */
export const submitBugReport = async ({ title, description, files = [] }) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("description", description);
  for (const file of files) {
    formData.append("attachments", file);
  }
  const response = await api.post("/bug-reports", formData);
  return response.data;
};
